const limitErrors = {
    "WOLI-429-01": "Sorry, I'm helping a lot of people at once right now! Can you please try again after a minute? I'll be available again soon!",
    "WOLI-429-02": "You've reached our limit of messages per conversation. Please start a new conversation.",
    "WOLI-429-03": "You've reached our limit of messages per hour. Please try again later.",
    "WOLI-429-04": "You've reached our limit of messages per day. Please try again later.",
}

export {
    limitErrors
}